import StatisticsAccount from 'modules/Statistics/Account/Account'
import Sagas from 'modules/Statistics/Account/saga'
import Reducer from 'modules/Statistics/Account/reducer'

export default StatisticsAccount

export { Sagas, Reducer }
